// extracted by mini-css-extract-plugin
export default {"createCenter":"edit-center_createCenter__Nh45c","submit":"edit-center_submit__5FeyD","content":"edit-center_content__208AM","rotate":"edit-center_rotate__8uxtH"};